//https://blog.logrocket.com/simplify-react-state-management-with-hookstate/
import { hookstate } from '@hookstate/core'

const globalObservationTeacherStore = hookstate({
});

export default globalObservationTeacherStore;